import { Button, Flex, Input, Table } from 'antd'
import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import {
    setFilter,
    setPagination,
    setSearchValue,
    testCaseState,
} from '../../../../redux/testCases/testCaseList.slice'
import { getColumns } from './TestCaseColums'
import { AppliedFilter } from './filter/AppliedFilter'
import CreateTestRunModal from '../../testRun/CreateTestRunModal'

// small debounce helper (no external deps)
const useDebounce = (value, delay = 400) => {
    const [v, setV] = useState(value)
    useEffect(() => {
        const t = setTimeout(() => setV(value), delay)
        return () => clearTimeout(t)
    }, [value, delay])
    return v
}

//==============================================================================================
const TestCaseList = (props) => {
    const { stateTestCase = {}, setStateTestCase = () => {} } = props

    const dispatch = useDispatch()

    // SELECTORS
    const {
        testCase = [],
        status = true,
        pagination: { pageSize = 10, currentPage = 0 },
        filter,
        defaultFilter,
        searchValue,
    } = useSelector(testCaseState)

    const testCaseListData = testCase?.data || []
    const listLoading = status === 'loading'
    const filterCount =
        (filter?.epic?.length ? 1 : 0) +
        (filter.sprint ? 1 : 0) +
        (filter?.tags?.length ? 1 : 0) +
        (searchValue?.length ? 1 : 0)

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [loading, setLoading] = useState(false)
    const [search, setSearch] = useState('')
    const [testRunModal, setTestRunModal] = useState(false)

    const handleAction = (act, id) => {
        if (act === 'edit' || act === 'view') {
            setStateTestCase({
                ...stateTestCase,
                drawerOpen: true,
                action: act,
                activeId: id,
            })
        }

        if (act === 'addResult') {
            setStateTestCase({
                ...stateTestCase,
                resultDrawer: true,
                action: act,
                activeId: id,
            })
        }
    }

    const clearAllFilter = () => {
        dispatch(setFilter(defaultFilter))
        dispatch(setSearchValue(''))
        setSearch('')
    }
    const clearSpecificFilter = (field) => {
        dispatch(
            setFilter({
                ...filter,
                [field]: ['epic', 'tags'].includes(field) ? [] : '',
            })
        )
        if (field === 'search') {
            dispatch(setSearchValue(''))
            setSearch('')
        }
    }

    // Get columns
    const columns = getColumns(handleAction)

    // ✅ Debounce the value
    const debouncedSearch = useDebounce(search, 500)

    // Dispatch search when debounced value changes (and reset to page 1)
    useEffect(() => {
        dispatch(setSearchValue(debouncedSearch?.trim() || ''))
        dispatch(setPagination({ pageSize, currentPage: 1 }))
    }, [debouncedSearch, dispatch, pageSize])
    // // Handle search change

    const start = () => {
        setLoading(true)
        // ajax request after empty completing
        setTimeout(() => {
            setSelectedRowKeys([])
            setLoading(false)
        }, 1000)
    }
    const onSelectChange = (newSelectedRowKeys) => {
        setSelectedRowKeys(newSelectedRowKeys)
    }
    const rowSelection = {
        selectedRowKeys,
        onChange: onSelectChange,
    }
    const hasSelected = selectedRowKeys.length > 0

    // AntD pagination config (controlled)
    const pagination = {
        current: currentPage,
        pageSize,
        total: testCase?.count || 100,
        showSizeChanger: true,
        pageSizeOptions: ['5', '10', '20', '50'],
        showTotal: (t, range) => `${range[0]}-${range[1]} of ${t}`,
        onChange: (page, size) => {
            // If user also changed size, AntD resets page to 1 by default—do it explicitly:
            if (size !== pageSize) {
                dispatch(
                    setPagination({
                        pageSize: size,
                        currentPage: 1,
                    })
                )
            } else {
                dispatch(
                    setPagination({
                        pageSize: size,
                        currentPage: page,
                    })
                )
            }
        },
    }

    return (
        <Flex gap="middle" vertical>
            <Flex align="center" gap="10px" justify="space-between">
                {/* <AppliedFilter
                    data={filter}
                    onClearAll={() => {}}
                    onRemove={() => {}}
                /> */}
                <div
                    className=""
                    style={{
                        // position: 'absolute',
                        // bottom: 20,
                        left: 0,
                        padding: '0px',
                        // background: '#fff',
                        // width: '100%',
                        // borderTop: '1px solid #f0f0f0',
                    }}
                >
                    {hasSelected
                        ? `Selected ${selectedRowKeys.length} items`
                        : null}
                </div>
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'end',
                        alignItems: 'center',
                        gap: 10,
                        width: '70%',
                    }}
                >
                    <Button
                        type="default"
                        onClick={() => {
                            setStateTestCase({
                                ...stateTestCase,
                                filterDrawer: true,
                            })
                        }}
                        // disabled={!hasSelected}
                        loading={loading}
                        size="small"
                    >
                        Filter
                    </Button>
                    <Button
                        type="default"
                        onClick={() => {
                            setTestRunModal(true)
                        }}
                        disabled={!hasSelected}
                        loading={loading}
                        size="small"
                    >
                        Create Test Run
                    </Button>
                    <Input
                        size="large"
                        placeholder="Search test cases (title, id...)"
                        // allowClear
                        // enterButton
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{
                            maxWidth: 360,
                            lineHeight: 1.8,
                            borderRadius: '4px',
                        }}
                    />
                </div>
            </Flex>
            {!!filterCount && (
                <Flex align="center" gap="middle" justify="start">
                    <AppliedFilter
                        data={filter}
                        searchValue={searchValue}
                        onClearAll={clearAllFilter}
                        onRemove={clearSpecificFilter}
                    />
                </Flex>
            )}
            <div
                style={{
                    width: '100%',
                    marginTop: '7px',
                    position: 'relative',
                }}
            >
                {/* <div
                    style={{
                        width: '100%',
                        display: 'flex',
                        justifyContent: 'end',
                        marginBottom: 10,
                    }}
                >
                    <Input
                        size="large"
                        placeholder="Search test cases (title, description...)"
                        allowClear
                        // enterButton
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        style={{ maxWidth: 360 }}
                    />
                </div> */}
                <Table
                    style={{ width: '100%', overflow: 'auto' }}
                    // tableLayout="fixed"
                    rowSelection={rowSelection}
                    columns={columns}
                    dataSource={testCaseListData}
                    rowKey={'_id'}
                    loading={listLoading}
                    pagination={pagination}
                />
            </div>
            <CreateTestRunModal
                isOpen={testRunModal}
                setOpen={setTestRunModal}
                selectedRowKeys={selectedRowKeys}
            />
        </Flex>
    )
}
export default TestCaseList
